import React, { Dispatch, SetStateAction } from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { CalculationDifficultyOptions } from '../../../../commands/practitioner/enums/CalculationDifficultyOptions';
import { calculationDetailsStyles } from './style';
import OneBarIcon from '../../../../assets/interactive/CalculationOneBar.svg?react';
import TwoBarIcon from '../../../../assets/interactive/CalculationTwoBar.svg?react';
import ThreeBarIcon from '../../../../assets/interactive/CalculationThreeBar.svg?react';

interface CalculationDetailsProps {
  value: number;
  setValue: Function;
  setLastCalculationDifficulty: Dispatch<SetStateAction<number | undefined>>;
  calculation: number;
}

export function CalculationDetails(props: CalculationDetailsProps) {
  const { calculationDetails } = calculationDetailsStyles;
  const { value, setValue, setLastCalculationDifficulty, calculation } = props;

  const handleAlignment = (event: React.MouseEvent<HTMLElement>, newValue: number | null) => {
    if (newValue !== null) {
      setValue(newValue);
      setLastCalculationDifficulty(newValue);
    }
  };

  return (
    <Box sx={calculationDetails}>
      <Box className="mask">
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleAlignment}
          aria-label="calculation difficulty"
          className={'toggle-group'}
          disabled={calculation === 0}
        >
          <ToggleButton className="toggle-button easy" value={CalculationDifficultyOptions.Easy} aria-label="easy">
            <OneBarIcon className="button-icon" />
          </ToggleButton>
          <ToggleButton
            className="toggle-button medium"
            value={CalculationDifficultyOptions.Medium}
            aria-label="medium"
          >
            <TwoBarIcon className="button-icon" />
          </ToggleButton>
          <ToggleButton className="toggle-button hard" value={CalculationDifficultyOptions.Hard} aria-label="hard">
            <ThreeBarIcon className="button-icon" />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
